import { gql } from '@apollo/client';

export const SendHelpdesk = gql`
  mutation SendHelpdesk(
    $description: String!
    $details: String!
    $userName: String!
    $phoneNumber: String!
    $email: String!
    $Attachments: [Upload!]!
  ) {
    SendHelpdesk(
      input: {
        Details: $details
        Description: $description
        UserName: $userName
        PhoneNumber: $phoneNumber
        Email: $email
        Attachments: $Attachments
      }
    ) @rest(type: "File", path: "/Ticket/send-helpdesk", method: "POST", bodySerializer: "fileEncode") {
      errors {
        ...Error
      }
    }
  }
`;

export const SendSupport = gql`
  mutation SendSupport(
    $description: String!
    $userName: String!
    $phoneNumber: String!
    $email: String!
    $subject: String!
    $attachments: [Upload!]!
  ) {
    SendSupport(
      input: {
        Description: $description
        UserName: $userName
        PhoneNumber: $phoneNumber
        Email: $email
        Subject: $subject
        Attachments: $attachments
      }
    ) @rest(path: "/Ticket/send-support", method: "POST", bodySerializer: "fileEncode")
  }
`;

export const SendContentFeedback = gql`
  mutation SendContentFeedback(
    $accomodationObjectCid: String!
    $message: String!
    $attachments: [Upload!]!
    $userName: String!
    $phoneNumber: String!
    $email: String!
  ) {
    SendContentFeedback(
      input: {
        AccomodationObjectCid: $accomodationObjectCid
        Message: $message
        UserName: $userName
        PhoneNumber: $phoneNumber
        Email: $email
        Attachments: $attachments
      }
    ) @rest(path: "/FeedbackForm/send-content-feedback", method: "POST", bodySerializer: "fileEncode")
  }
`;
